import React, { FunctionComponent } from "react";
import { Badge, Skeleton } from "@chakra-ui/react";
import { useIntl } from "react-intl";


interface IProps {
  state?: number;
}


export const GENSET_STATE = {
  NONE: 0,
  RUNNING: 1,
  STARTING: 2,
  OFF: 3,
  ERROR: 4,
}


const GensetState: FunctionComponent<IProps> = ({ state }) => {
  const intl = useIntl();

  switch (state) {
    case GENSET_STATE.NONE:
      return (
        <Badge colorScheme={"gray"}>
          {intl.formatMessage({
            id: "genset__state__none",
            defaultMessage: "-",
          })}
        </Badge>
      )
    case GENSET_STATE.RUNNING:
      return (
        <Badge variant="solid" colorScheme={"green"}>
          {intl.formatMessage({
            id: "genset__state__running",
            defaultMessage: "RUNNING",
          })}
        </Badge>
      )
    case GENSET_STATE.STARTING:
      return (
        <Badge variant="solid" colorScheme={"yellow"}>
          {intl.formatMessage({
            id: "genset__state__starting",
            defaultMessage: "STARTING",
          })}
        </Badge>
      )
    case GENSET_STATE.ERROR:
      return (
        <Badge variant="solid" colorScheme={"red"}>
          {intl.formatMessage({
            id: "genset__state__error",
            defaultMessage: "ERROR",
          })}
        </Badge>
      )
    case GENSET_STATE.OFF:
      return (
        <Badge variant="solid" colorScheme={"blue"}>
          {intl.formatMessage({
            id: "genset__state__off",
            defaultMessage: "OFF",
          })}
        </Badge>
      )
    default:
      return (
        <Skeleton minW={5} w={10} h={3} />
      )
  }
};

export default GensetState;
